import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

export const omuPointsList = (request) => {

    let ENDPOINT = URL_BASE_API+'super-admin/pointsettings/';      

    return service.get(ENDPOINT);
    
};

export const omuPointsSave = (request) => {
    
    let ENDPOINT = URL_BASE_API+'super-admin/pointsettings-edit/';      

    return service.put(ENDPOINT,request.data);
    
};